import { useState, useEffect } from 'react'
import { PageHeader } from '../components/UI'
import { get } from '../utils/api'
import { useAuth } from '../context/AuthContext'
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react'

export default function AvailabilityPage() {
  const { hotel } = useAuth()
  const [startDate, setStartDate] = useState(() => new Date().toISOString().split('T')[0])
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)

  const load = async () => { try { const r = await get('/availability', { start: startDate, days: 14 }); setData(r.data || r) } catch {} finally { setLoading(false) } }
  useEffect(() => { load() }, [startDate])

  const shift = (n) => { const d = new Date(startDate); d.setDate(d.getDate() + n); setStartDate(d.toISOString().split('T')[0]) }

  const occColor = (pct) => pct >= 90 ? 'bg-danger-lt' : pct >= 75 ? 'bg-warning-lt' : 'bg-success-lt'

  if (loading) return <div className="text-center py-5"><div className="spinner-border text-primary" /></div>

  return (
    <>
      <PageHeader title="Availability Grid" subtitle={`${hotel?.name || 'Hotel'} — ${hotel?.total_rooms || 220} total rooms`} />
      <div className="d-flex align-items-center gap-2 mb-3">
        <button className="btn btn-ghost-secondary btn-icon btn-sm" onClick={() => shift(-7)}><IconChevronLeft size={18} /></button>
        <input type="date" className="form-control form-control-sm" style={{ maxWidth: 160 }} value={startDate} onChange={e => setStartDate(e.target.value)} />
        <button className="btn btn-ghost-secondary btn-icon btn-sm" onClick={() => shift(7)}><IconChevronRight size={18} /></button>
        <button className="btn btn-outline-secondary btn-sm" onClick={() => setStartDate(new Date().toISOString().split('T')[0])}>Today</button>
        <div className="d-flex gap-3 ms-3" style={{ fontSize: '0.75rem' }}>
          <span className="d-flex align-items-center gap-1"><span className="badge bg-success-lt">&nbsp;</span>Under 75%</span>
          <span className="d-flex align-items-center gap-1"><span className="badge bg-warning-lt">&nbsp;</span>75-89%</span>
          <span className="d-flex align-items-center gap-1"><span className="badge bg-danger-lt">&nbsp;</span>90%+</span>
        </div>
      </div>
      <div className="card">
        <div className="table-responsive">
          <table className="table table-vcenter table-bordered table-sm card-table mb-0">
            <thead>
              <tr>
                <th style={{ minWidth: 120, position: 'sticky', left: 0, background: 'var(--tblr-bg-surface)', zIndex: 1 }}>Metric</th>
                {data.map(d => {
                  const dt = new Date(d.date + 'T00:00:00')
                  const isWeekend = dt.getDay() === 0 || dt.getDay() === 5 || dt.getDay() === 6
                  return (
                    <th key={d.date} className="text-center" style={{ minWidth: 70, background: isWeekend ? 'var(--tblr-bg-surface-secondary)' : undefined }}>
                      <div style={{ fontSize: '0.7rem' }}>{dt.toLocaleDateString('en-US', { weekday: 'short' })}</div>
                      <div style={{ fontSize: '0.8rem', fontWeight: 600 }}>{dt.getDate()}</div>
                    </th>
                  )
                })}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="fw-medium" style={{ position: 'sticky', left: 0, background: 'var(--tblr-bg-surface)', zIndex: 1 }}>Occupancy %</td>
                {data.map(d => { const pct = Math.round((d.sold / d.total) * 100); return <td key={d.date} className={`text-center fw-bold ${occColor(pct)}`}>{pct}%</td> })}
              </tr>
              <tr>
                <td style={{ position: 'sticky', left: 0, background: 'var(--tblr-bg-surface)', zIndex: 1 }}>Rooms Sold</td>
                {data.map(d => <td key={d.date} className="text-center">{d.sold}</td>)}
              </tr>
              <tr>
                <td style={{ position: 'sticky', left: 0, background: 'var(--tblr-bg-surface)', zIndex: 1 }}>Available</td>
                {data.map(d => <td key={d.date} className={`text-center ${d.available < 25 ? 'text-danger fw-bold' : 'text-success'}`}>{d.available}</td>)}
              </tr>
              <tr>
                <td style={{ position: 'sticky', left: 0, background: 'var(--tblr-bg-surface)', zIndex: 1 }}>Group Blocked</td>
                {data.map(d => <td key={d.date} className="text-center text-primary">{d.group_blocked}</td>)}
              </tr>
              <tr>
                <td style={{ position: 'sticky', left: 0, background: 'var(--tblr-bg-surface)', zIndex: 1 }}>Transient</td>
                {data.map(d => <td key={d.date} className="text-center">{d.transient}</td>)}
              </tr>
              <tr>
                <td className="fw-medium" style={{ position: 'sticky', left: 0, background: 'var(--tblr-bg-surface)', zIndex: 1 }}>ADR</td>
                {data.map(d => <td key={d.date} className="text-center fw-medium">${d.rate}</td>)}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
